import Button from "@mui/material/Button"
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 400,
    padding: '3px 12px',
    backgroundColor: '#eeeeee',
    color: 'grey',
    border: `1px solid ${theme.palette.secondary.light}`,
    lineHeight: 1.5,
    // color: 'white',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.dark
    },
    '&:focus': {
      boxShadow:   '0 0 0 0.2rem rgba(0,123,255,.5)',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText
      
    },
})); 

export default function BootstrapButton({children, ...rest}) {
    return <StyledButton {...rest}>{children}</StyledButton>
}
